<template>
  <div class="header">
    <div class="header-content" @mousemove="tabshow('0')">
      <img src="@/assets/img/public/637.png" class="img" />
      <ul v-show="pCtrl" @mousemove.stop.prevent>
        <template v-for="(item, index) in routerList">
          <li
            v-if="!item.hidden"
            :key="index"
            @mousemove.stop.prevent="tabshow(index, item, $route.path)"
            :class="{
              active: cur == index
            }"
          >
            <span v-if="!!item.children">{{ item.title }}</span>
            <span v-else>
              <router-link :to="item.path">{{ item.title }}</router-link>
            </span>
          </li>
        </template>
      </ul>
      <ol v-show="pCtrl">
        <!-- <li>登录</li> -->
        <li>
          <span @click="linkTo('/register')">注册</span>
        </li>
      </ol>
      <div v-show="!pCtrl">
        <div class="btn__box">
          <span class="btn-detail" @click="linkTo('/home')">返回首页</span>
        </div>
      </div>
    </div>
    <!-- v-if="cur == index" -->

    <div class="tab-content" v-if="isShow">
      <template v-for="(item, index) in routerList[cur].children">
        <template v-if="!!item.children">
          <div class="item" :key="index">
            <div class="title">{{ item.title }}</div>
            <div
              v-for="(subItem, subIndex) in item.children"
              :key="index + '' + subIndex"
              class="target"
              :class="{ 'target-active': subItem.path === $route.path }"
            >
              <router-link :to="subItem.path">{{ subItem.title }}</router-link>
            </div>
          </div>
        </template>
        <div
          v-else
          :key="index"
          class="itemF target"
          :class="{ 'target-active': item.path === $route.path }"
        >
          <router-link :to="item.path">{{ item.title }}</router-link>
        </div>
      </template>
    </div>
    <div class="model" @mousemove="tabshow('0')" v-if="isShow"></div>
  </div>
</template>

<script>
export default {
  props: {
    pCtrl: {
      type: [Boolean],
      default: true
    }
  },
  data() {
    return {
      routerList: [],
      cur: 0,
      isShow: false,
      itemcon: false
    };
  },
  created() {
    this.routerList = this.$router.options.routes;
    // console.log(this.routerList);
    this.isShow = false;
    for (const obj of this.routerList.entries()) {
      if (this.$route.path.indexOf(obj[1].name) > -1) {
        this.cur = obj[0];
        return;
      }
    }
  },
  methods: {
    tabshow(val) {
      if (!isNaN(val) && this.routerList[val].children) {
        this.cur = val;
        this.isShow = true;
      } else {
        // this.cur = 0;
        this.isShow = false;
        for (const obj of this.routerList.entries()) {
          if (this.$route.path.indexOf(obj[1].name) > -1) {
            this.cur = obj[0];
            return;
          }
        }
      }
    },
    linkTo(url) {
      this.$router.push({
        path: url
      });
    },
    isLogin() {
      this.$message({
        message: "内部人员账号",
        type: "warning"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  user-select: none;
  box-sizing: border-box;
  border-bottom: solid rgba(41, 43, 58, 0.05) 1px;
  height: 62px;

  .header-content {
    width: 1200px;
    line-height: 62px;
    margin: 0 auto;
    // overflow: hidden;
    .img {
      float: left;
      margin: 15px 68px 15px 0;
      width: 127px;
      height: 31px;
    }
    ul {
      float: left;
      margin: 0;
      padding: 0;
      list-style: none;
      overflow: hidden;
      height: 62px;
      li {
        float: left;
        margin-right: 50px;
        span {
          display: inline-block;
          height: 60px;
          line-height: 62px;
          font-size: 16px;
          cursor: pointer;
        }
        span a {
          display: inline-block;
          height: 58px;
          line-height: 62px;
        }
        .active {
          border-bottom: #3e71ff 2px solid;
        }
      }
      li:hover span {
        border-bottom: #3e71ff 4px solid;
      }
      li.active span {
        border-bottom: #3e71ff 4px solid;
      }
    }
    ol {
      float: right;
      margin: 0;
      padding: 0;
      list-style: none;
      overflow: hidden;
      li {
        margin-left: 26px;
        height: 62px;
        float: left;
        cursor: pointer;
      }
      li:last-child span {
        display: inline-block;
        margin: 15px 0;
        border-radius: 30px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        background-color: #3e71ff;
        color: #fff;
      }
    }
    .btn__box {
      text-align: right;
      .btn-detail {
        display: inline-block;
        text-align: center;
        width: 92px;
        height: 30px;
        border-radius: 19px;
        font-size: 14px;
        font-weight: 400;
        line-height: 30px;
        color: rgba(62, 113, 255, 1);
        border: 1px solid #3e71ff;
        cursor: pointer;
      }
      .btn-detail:hover {
        background: rgba(62, 113, 255, 1);
        box-shadow: 0px 3px 6px rgba(62, 113, 255, 0.2);
        color: rgba(255, 255, 255, 1);
        border: 1px solid rgba(62, 113, 255, 0.2);
      }
    }
  }
  .tab-content {
    position: absolute;
    top: 62px;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 9999;
    .item {
      display: inline-block;
      width: 240px;
      text-align: left;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: rgba(41, 43, 58, 0.5);
      .title {
        padding-top: 35px;
        padding-bottom: 25px;
      }
      .target {
        padding-bottom: 25px;
      }
    }
    .itemF {
      display: inline-block;
      width: 220px;
      text-align: left;
      margin-top: 35px;
      margin-bottom: 5px;
    }
    .target {
      padding-bottom: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: rgba(41, 43, 58, 1);
    }
    .target a:hover {
      color: rgba(62, 113, 255, 1);
    }
    .target-active a {
      color: rgba(62, 113, 255, 1);
    }
  }
  .model {
    position: fixed;
    top: 62px;
    left: 0;
    z-index: 112;
    width: 100%;
    height: 100%;
    background-color: transparent;
  }
}
</style>
